module.exports = __webpack_public_path__ + "img/icon_map_4_yj_c.d4ecebc6.png";